export default function (store, config) {
    store.setState({
        stateDueDate: config,
    });
}
//# sourceMappingURL=duedate.js.map